window.WeightWatchers = (function ($, util, components) {
    window.dataLayer = window.dataLayer || [];
    const ButtonLink = $('#buttonLink').val();
    const self = {
        gtm: {
            event: {
                clickedGenerateCode: 'User clicked on generate code button',
                clickedCopyCode: 'User has generated a code and clicked go to ww',
                gotToWW: 'User previously generated a code and clicked go to ww',
                error: 'An error has occurred'
            },
            section: {
                signUp: 'Sign up page',
                codeModal: 'Member sign up code generated modal',
                error: 'Error page shown to user'
            }
        },
        state: {
            voucherCode: '',
            isNorthernIrelandUser: false
        },
        elements: {
            buttons: {
                wwEmailModalClose: '#ww-email-modal .vds-modal__close',
                signUpButton: '#compliance-sign-up-button',
                goToWWButton: '#compliance-book-now-button',
                wwGenerateVoucherModalClose: '#ww-copy-code-modal .vds-modal__close',
                wwTryAgainModalClose: '#ww-tryagain-modal .vds-modal__close',
                copyCodeButton: '#ww-copy-code-button',
                wwGenerateVoucherModalCancel: '#ww-copy-code-cancel-button',
                wwTryAgainModalOkButton: '#ww-tryagain-button',
                wwEmailModalOkButton: '#ww-email-close-button'
            },
            ids: {
                wwVoucherCode: '#voucher-code',
                wwGenerateVoucherModal: 'ww-copy-code-modal',
                wwGenerateVoucherModalTarget: '#ww-copy-code-modal',
                wwTryAgainModal: 'ww-tryagain-modal',
                wwEmailModal: 'ww-email-modal'
            }
        },
        urls: {
            generateVoucher: '/api/sitecore/WeightWatchersSignUp/GetVoucherCode',
            errorPage: '/error/error-page'
        },
        func: {
            init: function (viewData) {
                self.func.generateCode.code(viewData);
                if (self.state.voucherCode) {
                    $(components.ComplianceInformation.Elements.Buttons.BookNowButton).show();
                    $(components.ComplianceInformation.Elements.Buttons.SignUpButton).hide();
                } else {
                    $(components.ComplianceInformation.Elements.Buttons.BookNowButton).hide();
                    $(components.ComplianceInformation.Elements.Buttons.SignUpButton).show();
                }
                self.func.bindings();
                self.func.gtm();
            },
            gtm: function () {
                $(self.elements.buttons.signUpButton).on('click',
                    function () {
                        (window.dataLayer.push({
                            event: self.gtm.event.clickedGenerateCode,
                            section: self.gtm.section.signUp
                        }));
                    });
                $(self.elements.buttons.copyCodeButton).on('click',
                    function () {
                        (window.dataLayer.push({
                            event: self.gtm.event.clickedCopyCode,
                            section: self.gtm.section.codeModal
                        }));
                    });
                $(self.elements.buttons.goToWWButton).on('click',
                    function () {
                        (window.dataLayer.push({
                            event: self.gtm.event.gotToWW,
                            section: self.gtm.section.signUp
                        }));
                    });
            },
            bindings: function () {
                $(self.elements.buttons.goToWWButton).on('click',
                    self.func.copyAndGo);
                $(components.ComplianceInformation.Elements.Buttons.SignUpButton).on('click',
                    self.func.handleSignUpButtonClick);
                $(components.ComplianceInformation.Elements.Buttons.RefreshButton).on('click',
                    util.func.reloadPage);
                $(self.elements.buttons.wwGenerateVoucherModalClose).on('click',
                    util.func.reloadPage);
                $(self.elements.buttons.wwGenerateVoucherModalCancel).on('click',
                    util.func.reloadPage);
                $(self.elements.buttons.wwEmailModalOkButton).on('click',
                    util.func.reloadPage);
                $(self.elements.buttons.copyCodeButton).on('click',
                    self.func.copyAndGo);
            },
            handleSignUpButtonClick: function () {
                if (components.ComplianceInformation.Func.IsSignUpButtonEnabled()) {
                    if (self.state.voucherCode !== null && self.state.voucherCode !== '') {
                        components.ComplianceInformation.Func.SwitchToRefreshButton();
                        util.func.reloadPage();
                    } else {
                        self.func.generateVoucher();
                    }

                    components.ComplianceInformation.Func.SwitchToPleaseWaitButton();
                }
            },
            generateCode: {
                code: function (viewData) {
                    self.state.voucherCode = viewData.VoucherCode;
                    self.state.isNorthernIrelandUser = viewData.IsNorthernIreland;
                    if (!viewData.IsNorthernIreland && viewData.VoucherCode !== null && viewData.VoucherCode !== '') {
                        $(components.ComplianceInformation.Elements.Buttons.SignUpButton).text(viewData.CopyCodeButtonText);
                    }
                }
            }, generateVoucher: function () {
                util.func.callWebApi({
                    type: 'GET',
                    url: self.urls.generateVoucher,
                    data: {isNorthernIrelandUser: self.state.isNorthernIrelandUser}
                }).done(function (data) {
                    self.func.generateVoucherSuccess(data);
                }).fail(function (error) {
                    self.func.generateVoucherError(error);
                });
            },
            generateVoucherSuccess: function (data) {
                self.state.voucherCode = data.voucherCode;
                if (data.statusCode === util.httpStatusCodes.ok) {
                    if (self.state.isNorthernIrelandUser && data.emailSent) {
                        self.func.openEmailModal();
                        components.ComplianceInformation.Func.SwitchToRefreshButton();
                    } else if (data.voucherCode !== null) {
                        $(self.elements.buttons.copyCodeButton).attr('data-copycontent', data.voucherCode);
                        self.func.openCopyCodeModal();
                        components.ComplianceInformation.Func.SwitchToRefreshButton();
                    } else {

                        components.ComplianceInformation.Func.SwitchToRefreshButton();
                    }
                } else if (data.statusCode === util.httpStatusCodes.unprocessableEntity) {

                    components.ComplianceInformation.Func.SwitchToRefreshButton();
                } else {
                    self.func.redirectToErrorPage();
                    //GTM
                    window.dataLayer.push({
                        event: self.gtm.event.error,
                        section: self.gtm.event.error,
                        statusCode: data.statusCode
                    });
                }
            },
            generateVoucherError: function (jqxhr) {
                if (jqxhr.statusCode === util.httpStatusCodes.loginTimeout) {
                    util.func.reloadPage();
                } else if (jqxhr.statusCode === util.httpStatusCodes.unprocessableEntity) {

                    components.ComplianceInformation.Func.SwitchToRefreshButton();
                } else {
                    self.func.redirectToErrorPage();
                    //GTM
                    window.dataLayer.push({
                        event: self.gtm.event.error,
                        section: self.gtm.event.error,
                        statusCode: jqxhr.statusCode
                    });
                }
            },
            redirectToErrorPage: function () {
                util.func.redirect(self.urls.errorPage);
            },
            openCopyCodeModal: function () {
                $(self.elements.ids.wwVoucherCode).text(self.state.voucherCode);
                util.func.openModal(self.elements.ids.wwGenerateVoucherModal);
            },
            openEmailModal: function () {
                util.func.openModal(self.elements.ids.wwEmailModal);
            },
            copyAndGo: function () {
                self.func.copyVoucherCode();
                if ($(self.elements.ids.wwGenerateVoucherModalTarget).is(':visible')) {
                    util.func.openInNewTab(ButtonLink);
                }

            },
            copyVoucherCode: function () {
                const textToCopy = $(self.elements.ids.wwVoucherCode).text();
                navigator.clipboard.writeText(textToCopy).catch(error => {
                    window.dataLayer.push({
                        event: self.gtm.event.error,
                        details: 'Error copying text: ', error
                    });
                });
            }
        }
    };

    return {
        init: self.func.init
    };
})(window.jQuery, window.Utilities, { ComplianceInformation: window.ComplianceInformation });

$('document').ready(function () {
    if ('weightwatchers' === $('#page-data').data('feature')) {
        const viewData = $('#page-data').data('model');
        window.WeightWatchers.init(viewData);
    }
});
